import React from 'react';
import Icon from '../../../components/AppIcon';

const AuditStatistics = ({ stats }) => {
  const statCards = [
    {
      label: 'Total Events',
      value: stats?.totalEvents || 0,
      icon: 'Activity',
      color: 'var(--color-primary)'
    },
    {
      label: 'Suspicious Activities',
      value: stats?.suspiciousCount || 0,
      icon: 'AlertTriangle',
      color: 'var(--color-warning)'
    },
    {
      label: 'Critical Events',
      value: stats?.bySeverity?.critical || 0,
      icon: 'AlertOctagon',
      color: 'var(--color-error)'
    },
    {
      label: 'Admin Actions',
      value: stats?.byEventType?.admin_action || 0,
      icon: 'UserCheck',
      color: 'var(--color-info)'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {statCards?.map((stat, index) => (
        <div key={index} className="card">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-muted-foreground mb-1">{stat?.label}</p>
              <p className="text-3xl font-heading font-bold text-foreground">{stat?.value}</p>
            </div>
            <div
              className="w-12 h-12 rounded-lg flex items-center justify-center"
              style={{ backgroundColor: `${stat?.color}15` }}
            >
              <Icon name={stat?.icon} size={24} color={stat?.color} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AuditStatistics;